const config = {
  API_URL: process.env.REACT_APP_API_ENDPOINT || '',
  KEY_RECAPTCHA: process.env.REACT_APP_SITE_KEY || ''
}

export default config
